// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"c60dcee5","703":"7c53f884","787":"4155dbad"}[chunkId] + ".chunk.js";
};